import React, { useState } from "react";
import config from "../../../config/config";
import { QuoteBreakUp } from "./QuoteBreakUp";
import { QuoteProfile } from "./QuoteProfile";
import { QuoteInclusions } from "./QuoteInclusions";
import { QuotePolicies } from "./QuotePolicies";
import { useHistory } from "react-router-dom";
export function VendorQuoteList(props) {
  const { estimateComparison, estimateId } = props;
  const JSX = (
    <>
      <div className="row">
        <div className="col-12">
          <div className="my-3">
            <h6 className="">{estimateComparison.length} - Quotes Received </h6>
          </div>
          {/* quotes list */}
          {estimateComparison.map((quoteData) => (
            <VendorQuote quote={quoteData} estimateId={estimateId} />
          ))}
        </div>
      </div>
    </>
  );
  return JSX;
}
export function VendorQuote(props) {
  const { quote, estimateId } = props;
  const [quoteInfoType, setQuoteInfoType] = useState("");
  const history = useHistory();
  const JSX = (
    <>
      <div className="vendor-quote-list-container">
        <div className="row">
          <div className="col-sm-12 col-md-10">
            <div className="row">
              <div className="col-sm-12 col-md-4 list-content">
                <div className="d-flex flex-row">
                  <div className="mr-1">
                    {/* TODO: Dynamic vendor logo */}
                    <img
                    src={`${config.vendorImagesPath}${quote["vendor_id"]}/${quote["logo"]}`}
                      alt="logo"
                      width="50"
                      height="50"
                      className="img-fluid vendor-logo"
                    />
                  </div>
                  <div className="quote-label">{quote["business_name"]}s</div>
                </div>
              </div>
              <div className="col-sm-12 col-md-3 list-content">
                <div className="quote-label">No of Days for Delivery</div>
                <div className="quote-data">
                  {quote["addition_info"]["Days for delivery"]}
                </div>
              </div>
              <div className="col-sm-12 col-md-3 list-content">
                <div className="quote-label"> Vehicle</div>
                <div className="quote-data">
                  {quote["addition_info"]["Vehicle Type"]}{" "}
                </div>
              </div>
              <div className="col-sm-12 col-md-2 list-content">
                <div className="quote-label">Amount</div>
                <div className="quote-data">₹ {quote["quote"]["sales_summary"]["total"]} /-</div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-2">
            <div className="d-flex align-items-center justify-content-center">
              <button
                className="btn btn-sm btn-primary w-100"
                onClick={() => {
                  history.push(`/payment-checkout/${estimateId}/${quote["vendor_id"]}`);
                }}
              >
                Book
              </button>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-10">
            <div className="vendor-quote-info-list">
              <div
                className={`list-link ${
                  quoteInfoType === "profile" ? "active-link" : ""
                }`}
                onClick={() =>
                  setQuoteInfoType(quoteInfoType === "profile" ? "" : "profile")
                }
              >
                Profile
              </div>
              <div
                className={`list-link ${
                  quoteInfoType === "inclusions" ? "active-link" : ""
                }`}
                onClick={() =>
                  setQuoteInfoType(
                    quoteInfoType === "inclusions" ? "" : "inclusions"
                  )
                }
              >
                Inclusions
              </div>
              <div
                className={`list-link ${
                  quoteInfoType === "fare_breakup" ? "active-link" : ""
                }`}
                onClick={() =>
                  setQuoteInfoType(
                    quoteInfoType === "fare_breakup" ? "" : "fare_breakup"
                  )
                }
              >
                Fare BreakUp
              </div>
              <div
                className={`list-link ${
                  quoteInfoType === "policies" ? "active-link" : ""
                }`}
                onClick={() =>
                  setQuoteInfoType(
                    quoteInfoType === "policies" ? "" : "policies"
                  )
                }
              >
                Policies
              </div>
            </div>
          </div>
        </div>
      </div>
      {quoteInfoType !== "" && (
        <div className="vendor-quote-info-container">
          {quoteInfoType === "profile" && (
            <QuoteProfile
              vendorName={quote["business_name"]}
              aboutUs={quote["about_us"]}
              successfulMoves={quote["successful_moves"]}
              happyClients={quote["happy_clients"]}
              yearsOfService={quote["years_of_service"]}
              address={quote["address"]}
              logo={quote["logo"]}
              vendorId={quote["vendor_id"]}
              vendorUrlName={quote["url_name"]}
            />
          )}
          {quoteInfoType === "inclusions" && (
            <QuoteInclusions quote={quote["quote"]} />
          )}
          {quoteInfoType === "fare_breakup" && (
            <QuoteBreakUp quote={quote["quote"]} tax={{tax_name:quote["tax_name"],tax_value:quote["tax_value"]}}/>
          )}
          {quoteInfoType === "policies" && <QuotePolicies />}
        </div>
      )}
    </>
  );
  return JSX;
}
